import { Controller } from "@hotwired/stimulus"
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['tooltip', 'popover']

  connect() {
    if (this.tooltipTargets.length > 0) {
      this.tooltipTargets.forEach((el) => {
        this.mountTooltip(el)
        document.addEventListener('ajax:complete', () => {
          this.mountTooltip(el)
        }, {once: true})
        document.addEventListener('ajax:beforeSend', () => {
          this.unmountTooltip(el)
        }, {once: true})
        document.addEventListener('turbolinks:before-cache', () => {
          this.unmountTooltip(el)
        }, {once: true})
      })
    }

    if (this.popoverTargets.length > 0) {
      this.popoverTargets.forEach((el) => {
        this.mountPopover(el)
        document.addEventListener('ajax:complete', () => {
          this.mountPopover(el)
        }, {once: true})
        document.addEventListener('ajax:beforeSend', () => {
          this.unmountPopover(el)
        }, {once: true})
        document.addEventListener('turbolinks:before-cache', () => {
          this.unmountPopover(el)
        }, {once: true})
      })
    }
  }

  mountTooltip(el) {
    $(el).tooltip({
      trigger : 'hover'
    })
  }
  mountPopover(el) {
    $(el).popover()
  }
  unmountTooltip(el) {
    $(el).tooltip('dispose')
  }
  unmountPopover(el) {
    $(el).popover('dispose')
  }
}
